import Filters from "components/common/Filters";
import NoDataFound from "components/common/NoDataFound";

import {
  formatDate,
  getMinMaxDate,
  getRelativeTimeFromNow,
} from "components/common/Utils";
import { orderSpaceType } from "components/constants/DropdownOptions";
import {
  orderByOptions,
  orderStatusTypes,
  bookingTypes
} from "components/constants/StatusKeys";
import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getBranchListWithCity } from "store/actions/branchSlice";
import StartIcon from "assets/images/icons/star.svg";
import { getAllBookingHistory } from "store/actions/customerSlice";
import IsLoading from "components/common/IsLoading";
import Paginations from "components/common/Paginations";
import Riyal from "assets/images/icons/riyal.svg";

const BookingHistory = ({ id }) => {
  const { t } = useTranslation();

  const {
    loading2,
    perPage,
    totalCount2,
    totalPages2,
    currentPage2,
    bookingHistory,
  } = useSelector((state) => state.Customers);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [keyword, setKeyword] = useState("");
  const [dates, setDates] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({
    status: -1,
    orderBy: -1,
    spaceTypeInt: -1,
    branches: [],
    types: [],
  });

  useEffect(() => {
    dispatch(getBranchListWithCity());

    getAllData();
  }, []);

  const getAllData = (page, action) => {
    const { actionType } = action || {}; // SEARCH, RESET, RESET_KEYWORD
    const { orderBy, status, branches, types, spaceTypeInt } = selectedFilters;

    const isReset = actionType === "RESET";

    const payload = {
      id,
      perPage,
      pageNo: page || 1,
      status: isReset ? -1 : status,
      orderBy: isReset ? -1 : orderBy,
      keyword: ["RESET", "RESET_KEYWORD"].includes(actionType)
        ? ""
        : keyword || "",
      spaceTypeInt: isReset ? -1 : spaceTypeInt,
      branches: isReset ? [] : branches || [],
      bookingType: isReset ? [] : types || [],
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };
    dispatch(getAllBookingHistory(payload));
  };

  const handleReset = () => {
    setKeyword("");
    setDates([]);
    setSelectedFilters({
      orderBy: -1,
      status: -1,
      spaceTypeInt: -1,
      branches: [],
      types: [],
    });
    getAllData(1, { actionType: "RESET" });
  };

  const filters = [
    {
      key: "orderBy",
      placeholder: "Order By",
      options: orderByOptions,
      type: "singleSelect",
    },
    {
      key: "spaceTypeInt",
      placeholder: "Space Type",
      options: orderSpaceType,
      type: "singleSelect",
    },
    {
      key: "status",
      placeholder: "Status",
      options: orderStatusTypes,
      type: "singleSelect",
    },
    {
      key: "branches",
      type: "branchCityFilter",
    },
    {
      key: "types",
      placeholder: "Booking Type",
      options: bookingTypes,
      type: "multiSelect",
    },
  ];

  return (
    <div>
      {" "}
      <Filters
        keyword={keyword}
        setKeyword={setKeyword}
        selectedFilters={selectedFilters}
        setSelectedFilters={setSelectedFilters}
        dates={dates}
        setDates={setDates}
        filters={filters}
        onSearch={getAllData}
        onReset={handleReset}
      />
      <Row>
        <Col lg={12} style={{ minHeight: 170 }}>
          {loading2 ? (
            <IsLoading />
          ) : bookingHistory.length === 0 ? (
            <NoDataFound className="bg-white" />
          ) : (
            <div className="common_table_style">
              <Table>
                <thead className="t_head">
                  <tr>
                    <th>{t("Date")}</th>
                    <th>{t("Status")}</th>
                    <th>{t("Booking No")}</th>
                    <th>{t("User")}</th>
                    <th>{t("Number")}</th>
                    <th>{t("Booking Date")}</th>
                    <th>{t("Booking")}</th>
                    <th>{t("Qty")}</th>
                    <th>{t("Coupon")}</th>
                    <th>{t("Total")}</th>
                    <th>{t("Rating")}</th>
                  </tr>
                </thead>
                <tbody>
                  {bookingHistory?.map((item, index) => (
                    <tr
                      key={item?._id}
                      onClick={() =>
                        navigate(
                          `/bookings/bookings/booking-details?id=${item?._id}`
                        )
                      }
                    >
                      <td>
                        <p className="w_fit_content">
                          {getRelativeTimeFromNow(
                            item.createdAt,
                            item?.timezone
                          )}
                        </p>
                      </td>
                      <td>
                        <p
                          className={`w_fit_content ${
                            orderStatusTypes?.find(
                              (option) => option.value === item.bookingStatus
                            )?.class
                          }`}
                        >
                          {t(
                            orderStatusTypes?.find(
                              (option) => option.value === item.bookingStatus
                            )?.name
                          ) || "-"}
                        </p>
                      </td>
                      <td>#{item?.bookingNo || "-"}</td>
                      <td>{item?.user?.name || "-"}</td>
                      <td>{item?.user?.phone || "-"}</td>
                      <td>{formatDate(item?.bookingDate, "dd MMM yyyy")}</td>
                      <td>
                        <div style={{ minWidth: 200 }}>
                          <p>
                            {
                              orderSpaceType?.find(
                                (option) => option.value === item?.spaceTypeInt
                              )?.name
                            }{" "}
                            - {item?.space?.name}
                          </p>
                          <p className="fs_12 text_gray">
                            <span>{item?.city?.name}</span>
                            {", "}
                            <span>{item?.branch?.name}</span>
                          </p>
                        </div>
                      </td>
                      <td>
                        {item?.spaceTypeInt === 1
                          ? item?.numberOfseats
                          : [2, 3].includes(item?.spaceTypeInt)
                          ? `${item?.durationInHour}h`
                          : ""}
                      </td>
                      <td>
                        {item?.couponData?.code ? (
                          <p className="text_primary fs_12 text-decoration-underline">
                            {item?.couponData?.code}
                          </p>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        <p
                          className={` ${
                            item.bookingStatus === 3
                              ? "text_line_through text_gray"
                              : ""
                          }`}
                        >
                          <img
                            src={Riyal}
                            width={15}
                            height={15}
                            alt="riyal"
                            className="me-1"
                          />
                          {item?.splitPayments?.total}
                        </p>
                      </td>
                      <td>
                        <div className="d-flex gap-1">
                          <img src={StartIcon} alt="" width={16} height={16} />
                          <h2 className="fs_14"> {item?.rating}</h2>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}

          {!loading2 && (
            <Paginations
              currentPage={currentPage2}
              totalPages={totalPages2}
              onPageChange={(page) => {
                getAllData(page);
              }}
              totalCount={totalCount2}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BookingHistory;
